import React, { useState, useEffect } from 'react';
import useStyles from 'style/js-style/components/common/EAFormStepper';
import EAButton from './EAButton';
import clsx from 'clsx';
import i18next from 'i18next';
import useHideLocalize from './hooks/useHideLocalize';

const EAFormStepper = ({
  stepsContent,
  onClose,
  onNext,
  checkValidStep,
  finalStepText,
  onSubmit,
  isBreadCrumb = true,
  isFinalStep = true,
  getStepSetter,
}) => {
  const { classes } = useStyles();
  useHideLocalize();
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (getStepSetter) {
      getStepSetter(setCurrentStep, currentStep);
    }
  }, [getStepSetter, currentStep]);
  const breadCrumbList = stepsContent.filter((step) => !step.hideInBreadCrumb);

  const getNextButton = () => {
    if (stepsContent[currentStep].hideNextButton) {
      return <></>;
    } else if (stepsContent[currentStep].customNextButton) {
      return stepsContent[currentStep].customNextButton;
    }

    return (
      <div
        style={{
          position: 'absolute',
          width: '100%',
          bottom: '18px',
          boxSizing: 'border-box',
          padding: '0px 22px',
          zIndex: 2,

        }}
      >
        <EAButton
          onClick={async (e) => {
            e.stopPropagation();
            e.preventDefault();
            const isValid = await checkValidStep(currentStep);
            if (!isValid) return;

            if (currentStep === stepsContent.length - 1) {
              onSubmit();
            } else {
              onNext && onNext(stepsContent[currentStep].id);
              currentStep + 1 < stepsContent.length &&
                setCurrentStep(currentStep + 1);
            }
          }}
          content={
            currentStep === stepsContent.length - 1
              ? finalStepText
              : i18next.t('suivant')
          }
          size={'large'}
          customStyle={{
            width: '100%',
            borderRadius: '60px',
          }}
        />
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.leftPart}>
        <div
          onClick={() =>
            currentStep > 0 ? setCurrentStep(currentStep - 1) : onClose()
          }
          className={classes.navigation}
        >
          <img
            src={
              process.env.PUBLIC_URL + '/img/icons/arrow/arrow-back-long.svg'
            }
            alt="back"
            className={classes.backArrow}
          />
          <span className={classes.navigationText}>
            {currentStep > 0 ? 'Retour' : 'Quitter'}
          </span>
        </div>
        <div className={classes.leftContent}>
          {stepsContent[currentStep].left}
        </div>
      </div>
      <div className={classes.rightPart}>
        {isBreadCrumb ? (
          <div className={classes.breadCrumb}>
            {breadCrumbList.map((step, i) => {
              return (
                <React.Fragment key={step.name}>
                  <div
                    className={clsx(
                      classes.breadCrumbElement,
                      currentStep === i ? 'selected' : ''
                    )}
                    onClick={async () => {
                      const isValid = await checkValidStep(currentStep);
                      if (!isValid || i < currentStep) return;
                      setCurrentStep(i);
                    }}
                  >
                    {step.name}
                  </div>
                  {i < breadCrumbList.length - 1 && (
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        '/img/icons/arrow/arrow-breadcrumb.svg'
                      }
                      alt=">"
                      className={classes.breadCrumbArrow}
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        ) : (
          <></>
        )}
        <div className={classes.rightContent}>
          {stepsContent[currentStep].right}
        </div>
        {getNextButton()}
      </div>
    </div>
  );
};

export default EAFormStepper;
